import axios, { AxiosError, AxiosResponse } from 'axios'

import { RequestPayload } from '../constants/GlobalTypes'
import EnvironmentService from '../services/EnvironmentService'
import { withXSRFToken } from './handler'

export const API_VERSION = '/api/v2/supplier'

const fallbackError: AxiosError = {
  code: '404',
  name: '',
  message:
    'Unsere Server sind vorübergehend nicht verfügbar. Bitte versuchen Sie es in den nächsten Minuten erneut.',
  isAxiosError: true,
  config: null,
  toJSON: () => ({}),
  response: {
    status: 404,
    headers: null,
    config: null,
    data: 'Unsere Server sind vorübergehend nicht verfügbar. Bitte versuchen Sie es in den nächsten Minuten erneut.',
    statusText:
      'Unsere Server sind vorübergehend nicht verfügbar. Bitte versuchen Sie es in den nächsten Minuten erneut.'
  }
}

axios.defaults.withCredentials = true
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
axios.defaults.baseURL = `${EnvironmentService.getHostUrlValue()}${API_VERSION}`
axios.defaults.headers.common = {
  ...axios.defaults.headers.common,
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
}
axios.defaults.withXSRFToken = withXSRFToken // whitelist domain for xsrf token

class Api {
  static get<T>(url: string): Promise<AxiosResponse<T>> {
    return axios
      .get(url)
      .then((response) => {
        return response
      })
      .catch((error: AxiosError) => {
        throw Api.failureFallBack(error.response)
      })
  }

  static put<T>(
    url: string,
    payload?: RequestPayload<T>
  ): Promise<AxiosResponse<MemberSerializerResponse<T>>> {
    return axios
      .put(url, payload)
      .then((response) => {
        return response
      })
      .catch((error: AxiosError) => {
        throw Api.failureFallBack(error.response)
      })
  }

  static post<T>(
    url: string,
    payload?: RequestPayload<T>
  ): Promise<AxiosResponse<MemberSerializerResponse<T>>> {
    return axios
      .post(url, payload)
      .then((response) => {
        return response
      })
      .catch((error: AxiosError) => {
        throw Api.failureFallBack(error.response)
      })
  }

  static postWithMultipart<T>(
    url: string,
    payload?: RequestPayload<T>
  ): Promise<AxiosResponse<MemberSerializerResponse<T>>> {
    return axios
      .post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((response) => {
        return response
      })
      .catch((error: AxiosError) => {
        throw Api.failureFallBack(error.response)
      })
  }

  static delete<T>(url: string): Promise<AxiosResponse<MemberSerializerResponse<T>>> {
    return axios
      .delete(url)
      .then((response) => {
        return response
      })
      .catch((error: AxiosError) => {
        throw Api.failureFallBack(error.response)
      })
  }

  static failureFallBack(res: AxiosResponse) {
    return res ? res : fallbackError.response
  }
}

export default Api
